import { useViewerQuery } from '@/generated/graphql';
import store from '@/utils/local-storage';
import { useMemo } from 'react';

interface UseLocalStorageResult {
  store: Storage | null;
  setUserItem: (key: string, value: string) => void;
  getUserItem: (key: string) => string | null;
}

export function useLocalStorage(): UseLocalStorageResult {
  const { data } = useViewerQuery();
  const userId = data?.viewer?.id;

  return useMemo(
    () => ({
      store,
      setUserItem: (key: string, value: string): void => {
        if (userId) {
          store?.setItem(`user:${userId}|${key}`, value);
        }
      },
      getUserItem: (key: string): string | null =>
        (userId && store?.getItem(`user:${userId}|${key}`)) ?? null,
    }),
    [userId],
  );
}
